/* eslint-disable max-len */
import CifaAPI from "api/cifa/cifa.api";
import { FilterOptions, QueryBuilderOptions } from "utils/builderUtils";
import { create } from "zustand";
import { ICifaForm } from "./cifa.store";

interface IListCifaForm extends ICifaForm {
    responsavel: {
        uuid: string;
        name: string;
        identification: string;
    },
    institution: {
        uuid: string;
        name: string;
    }
}

interface IListagemCifaStore {
    listCifas: IListCifaForm[],
    loading: boolean,
    filtros: IFilterCifaForm,
    meta: Meta,
    getListCifas: (year: number, paginationOptions?: IFilterCifa) => Promise<boolean>,
    setListCifas: (listCifas: IListCifaForm[]) => void,
    setLoading: (loading: boolean) => void,
    setFiltros: (filtros: IFilterCifaForm) => void,
    clearFiltros: () => void,
}

export interface Meta {
    itemsPerPage: number
    totalItems: number
    currentPage: number
    totalPages: number
    sortBy: string[][]
    filter: IPropFiltersModel[]
}

interface IFilterCifaForm {
    institution: string;
    formulario_status: string;
    responsavel: string;
}


interface IPropFiltersModel extends FilterOptions {
    field: 'formulario_status' | 'responsavel.name' | 'institution.name';
}

interface IFilterCifa extends QueryBuilderOptions {
    filters?: IPropFiltersModel[];
}




const useListagemCifaStore = create<IListagemCifaStore>((set) => ({
    listCifas: [],
    filtros: {
        institution: '',
        formulario_status: '',
        responsavel: '',
    },
    meta: {
        itemsPerPage: 10,
        totalItems: 0,
        currentPage: 1,
        totalPages: 0,
        sortBy: [],
        filter: [],
    },
    loading: false,
    getListCifas: async (year: number, paginationOptions?: IFilterCifa) => {
        try {
            set({ loading: true });
            const queryParams = {
                page: paginationOptions?.page || 1,
                limit: paginationOptions?.limit || 10,
                search: paginationOptions?.search || '',
                filters: paginationOptions?.filters || [],
                sortBy: paginationOptions?.sortBy || []
            }
            const response = await CifaAPI.listarCifas(year, queryParams);
            set({ listCifas: response.dados.data, meta: response.dados.meta as Meta, loading: false });
            return true;
        } catch (error) {
            set({ loading: false });
            throw error;
        }
    },
    setListCifas: (listCifas: IListCifaForm[]) => set({ listCifas }),
    setLoading: (loading: boolean) => set({ loading }),
    setFiltros: (filtros: IFilterCifaForm) => set({ filtros }),
    clearFiltros: () => set({ filtros: { institution: '', formulario_status: '', responsavel: '' } }),
}))

export default useListagemCifaStore;